import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=61ad639b&scoped=true&"
import script from "./Back.vue?vue&type=script&lang=js&"
export * from "./Back.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/shared/Back/BackStyle.css?vue&type=style&index=0&id=61ad639b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad639b",
  null
  
)

export default component.exports